export const EXAMPLE_ENDPOINT = ''
export const HOME_CREDIT_BASE_PATH = 'app/credit-recovery/inter-ci-credito-service'
export const HOME_CREDIT_DEFAULT_PATH = 'loan-home'
export const HOME_CREDIT_ONBOARDING = `${HOME_CREDIT_BASE_PATH}/${HOME_CREDIT_DEFAULT_PATH}`
